export default __webpack_public_path__ + "static/media/chevron-down.cdccc6d4.svg";